import { useEffect, useState } from 'react';
import { captureErrorMessage } from '../../utilities/analytics/error-reporting';

import type { ZXCVBNResult } from 'zxcvbn';

type Zxcvbn = (password: string, userInputs?: string[]) => ZXCVBNResult;

export function useZxcvbn() {
  const [zxcvbn, setZxcvbn] = useState<Zxcvbn>();

  useEffect(() => {
    let isMounted = true;
    // asynchronously imported as package is very large
    import('zxcvbn')
      .then(zxcvbn => {
        if (isMounted) {
          setZxcvbn(() => {
            /**
             * We have this divergence since we use Webpack for Jest testing and Parcel for dev/prod.
             * Webpack dynamic import returns: { default: fn }
             * Parcel dynamic import returns: fn
             * Why can't we use Parcel for Jest? See: https://parceljs.org/languages/javascript/#usage-with-other-tools
             */
            return typeof zxcvbn === 'function' ? zxcvbn : zxcvbn.default;
          });
        }
      })
      .catch(e => {
        captureErrorMessage('Error while importing zxcvbn library', e);
        setZxcvbn(undefined);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return zxcvbn;
}
